import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BreadcrumbNavigation from 'components/ui/BreadcrumbNavigation';
import MetricCard from './components/MetricCard';
import ActivityFeed from './components/ActivityFeed';
import QuickActions from './components/QuickActions';
import ScheduleOverview from './components/ScheduleOverview';
import BusinessStatus from './components/BusinessStatus';
import { useSelector } from 'react-redux';
import { fetchDashboard } from 'services/reporting';
import { toast } from 'react-toastify';
import Button from 'components/ui/Button';
import Icon from 'components/AppIcon';

const AdminDashboard = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [dashboardMetrics, setDashboardMetrics] = useState([]);
  const navigate = useNavigate();
  const businessStore = useSelector((state) => state?.business);
  const user = useSelector((state) => state?.auth?.user);

  const formatTime = (time = '')=>{
    const formatted = time.substring(0,5);
    
  }
  const getDashboardData = async () => {
    if (businessStore?.selectedBusiness?.businessId) {
      try {
        const response = await fetchDashboard(businessStore?.selectedBusiness?.businessId);
        // Process and set dashboard data as needed
        if(response.success){
          const {revenueDashboard,staffDashboard,serviceDashboard,businessHoursDashboard} = response.data;
          const tempMetricHolder = [];
          if(revenueDashboard){
            const revenueMetrict = {
              title: "Today\'s Revenue",
              value: `R${revenueDashboard.totalRevenue}`,
              subtitle: `${revenueDashboard.completedBookings} services completed`,
              icon: "Wallet",
              variant: "revenue",
              trend: "stable",
              trendValue: "",
              onClick: () => navigate('/admin-dashboard')
            };
            tempMetricHolder.push(revenueMetrict)
          }

          if(staffDashboard){
            const staffMetric = {
              title: "Active Staff Members",
              value: `${staffDashboard.active}/${staffDashboard.active+staffDashboard.inActive}`,
              subtitle: staffDashboard.inActive == 0? "All staff are active": `-${staffDashboard.inActive} staff are inactive`,
              icon: "Users",
              variant: "staff",
              trend: staffDashboard.inActive == 0?"stable":"down",
              // trendValue: staffDashboard.inActive == 0? "0": `-${staffDashboard.inActive}`,
              onClick: () => navigate('/staff-management')
            };
            tempMetricHolder.push(staffMetric);
          }

          if(serviceDashboard){
            const serviceMetric = {
              title: "Services Offered",
              value: serviceDashboard.active,
              subtitle: serviceDashboard.inActive == 0? "All active": `${serviceDashboard.active}/${serviceDashboard.active+serviceDashboard.inActive} active`,
              icon: "Wrench",
              variant: "services",
              trend: serviceDashboard.inActive == 0?"stable":"down",
              // trendValue: serviceDashboard.inActive == 0? "0": `-${serviceDashboard.inActive}`,
              onClick: () => navigate('/service-management')
            };
            tempMetricHolder.push(serviceMetric);
          }

          if(businessHoursDashboard){
            const businessHoursMetric = {
              title: "Business Status",
              value: businessHoursDashboard.open? "OPEN": "CLOSED",
              subtitle: `Closes at ${businessHoursDashboard.closeTime}`,
              icon: "CheckCircle",
              variant: "status",
              trend: "up",
              // trendValue: businessHoursDashboard.open? "Online": "Offline",
              onClick: () => navigate('/business-profile-settings')
            };
            tempMetricHolder.push(businessHoursMetric);
          }
          setDashboardMetrics(tempMetricHolder);
          console.log(dashboardMetrics)
        }
        else{
          toast.error(response.message || 'Failed to fetch dashboard data');
          console.error('Failed to fetch dashboard data:', response.message);
        }
        console.log('Dashboard Data:', response.data);
      } catch (error) {
        toast.error('Error fetching dashboard data');
        console.error('Error fetching dashboard data:', error);
      }
    }
  }

  useEffect(() => {
    getDashboardData();
  }, [businessStore?.selectedBusiness]);
  
  // Update current time every minute
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);
    return () => clearInterval(timer);
  }, []);

  // Check authentication
  useEffect(() => {
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      navigate('/login');
    }
  }, [navigate]);

  return (
    <div className="p-6">
      {/* Breadcrumb Navigation */}
      <BreadcrumbNavigation className="mb-6" />

      {/* Dashboard Header */}
      <div className="mb-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="text-3xl font-bold text-foreground">Dashboard</h1>
            <p className="text-muted-foreground mt-2">
              Welcome back, {user?.name}. Here's what's happening at your car wash today.
            </p>
          </div>
          <div className="mt-4 sm:mt-0 text-right">
            <p className="text-sm text-muted-foreground">
              {currentTime?.toLocaleDateString('en-US', { 
                weekday: 'long', 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
              })}
            </p>
            <p className="text-lg font-semibold text-foreground">
              {currentTime?.toLocaleTimeString('en-US', { 
                hour: '2-digit', 
                minute: '2-digit' 
              })}
            </p>
          </div>
        </div>
      </div>

      {/* Metrics Cards Grid */}
      {(businessStore?.selectedBusiness?.owner || businessStore?.selectedBusiness?.admin || businessStore?.selectedBusiness?.reporting) &&
      <div>
        <div className='flex mb-4 justify-end items-center cursor-pointer' title="Refresh Dashboard" onClick={getDashboardData}>
          <Icon name="RefreshCcw" size={20} className="text-green-800  hover:text-green-700" />
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-8">
          {dashboardMetrics?.map((metric, index) => (
            <MetricCard
              key={index}
              title={metric?.title}
              value={metric?.value}
              subtitle={metric?.subtitle}
              icon={metric?.icon}
              variant={metric?.variant}
              trend={metric?.trend}
              trendValue={metric?.trendValue}
              onClick={metric?.onClick}
              className="group"
            />
          ))}
        </div>
      </div>
      }

      {/* Main Dashboard Content Grid */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mb-8">
        {/* Activity Feed - Takes 1 column */}
        {/* {(businessStore?.selectedBusiness?.owner || businessStore?.selectedBusiness?.admin || businessStore?.selectedBusiness?.reporting) &&
          <ActivityFeed className="xl:col-span-1" />
        } */}
        
        {/* Quick Actions - Takes 1 column */}
        {(businessStore?.selectedBusiness?.owner || businessStore?.selectedBusiness?.admin) && <QuickActions className="xl:col-span-1" />}
        
        {/* Schedule Overview - Takes 1 column */}
        {/* <ScheduleOverview className="xl:col-span-1" /> */}
      </div>

      {/* Business Status - Full Width */}
      {/* <div className="grid grid-cols-1 gap-6">
        <BusinessStatus />
      </div> */}

      {/* Footer Information */}
      {/* <div className="mt-8 pt-6 border-t border-border">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between text-sm text-muted-foreground">
          <div className="flex items-center space-x-4">
            <span>CarWash Manager v2.1.0</span>
            <span>•</span>
            <span>Last updated: {currentTime?.toLocaleTimeString()}</span>
          </div>
          <div className="mt-2 sm:mt-0">
            <span>© {new Date()?.getFullYear()} Premium Car Wash Center</span>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default AdminDashboard;